import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@modules/components/auth/auth.service';
import { UserRole } from '@shared/models/role';

export const studentsRoleMatchGuard =
  (...roles: UserRole[]): CanMatchFn =>
  () => {
    const authService = inject(AuthService);
    return roles.includes(authService.userRole);
  };
